import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};

  ${props =>
    props.isRequired &&
    `
    ::after {
      content: '*';
      color: ${tokens.color.error.main};
      padding-left: 2px;
    }
  `}
`
